export const APP_NAME = 'NanoImage2';
export const APP_BRAND_MARK_URL = '/brand/app-brand-mark.png';
export const GENERATION_ACTION_LOGO_URL = '/brand/generation-action-logo.png';
export const BRAND_GRADIENT = 'linear-gradient(135deg, #FF6B9D 0%, #A855F7 100%)';
